export function setPageTitle(title) {
    document.title = title + ' | Superplayer';
}
export function getSearchParam(name) {
    return new URLSearchParams(location.search).get(name);
}
